import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { RoutePaths } from '@shared/utils';
import { TransferRecipientTypeEnum } from '@shared/api/rest/recipients';
import { Icon, PageContainer, Text } from '@shared/widgets';
import { Tabs } from '@shared/widgets';
import { IndividualRecipient } from './subPages/individualRecipient';
import { BusinessRecipient } from './subPages/businessRecipient';
import ArrowIcon from '@assets/icons/arrow.svg';

interface RecipientEditorProps {
  loading?: boolean;
  recipientId?: string;
}

const allTabs = Object.entries(TransferRecipientTypeEnum).map((x) => ({ label: x[0], value: x[1] }));

export const RecipientEditor = (props: RecipientEditorProps) => {
  const params = useParams();
  const recipientId = props.recipientId || params.recipientId;
  const caption = recipientId ? 'Edit recipient' : 'Add New recipient';

  const [currentTab, setCurrentTab] = useState<TransferRecipientTypeEnum>(TransferRecipientTypeEnum.Individual);

  const currentTabView = currentTab == TransferRecipientTypeEnum.Individual ? <IndividualRecipient /> : <BusinessRecipient />;
  return (
    <PageContainer
      title='Add new recipient'
      header={
        <div className='flex gap-2 items-center'>
          <Link to={RoutePaths.payments.onNavigate()}>
            <Icon icon={<ArrowIcon />} className='rotate-180' />
          </Link>
          <Text weight='semibold' size='2xl'>
            Add new recipient
          </Text>
        </div>
      }
    >
      <div className='flex flex-col bg-white dark:bg-soft-black gap-6 p-6'>
        <Text weight='semibold' size='2xl'>
          {caption}
        </Text>
        <Tabs value={currentTab} options={allTabs} onChange={setCurrentTab} />
        {currentTabView}
      </div>
    </PageContainer>
  );
};
